export default {
    token: localStorage.getItem('vetc-token') || false,
    authStatus: '',
    authError: '',
}